module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAATCAYAAAB2pebxAAABGUlEQVQ4T2NkQAJaxyaeYmBk5EYWw2D/Z7h7zSrPD1mcEdWQSc8ZGBgk8BrCwHDumlWe8aghKKE0GiaYiQYzTDQP9Rv9Y2P8A1LL/I9pNwMDgxi+xPafgeHSP6Z/sWA1f/6xff//8y6j1tGJ5xkYGQ0IpFLs0v8Z9v1iZghkVDrTwc/xi2s/AwODISkG/Wdk3Had9XIAg8ms3+C8AzboJ+cBol3EyLjtGitbAINJ+m+QfngGVDozk5/j5w+CBoFcwMXKFnAWagCKIRAXzeTn+PXjAAMD9jD6z8Cw/Tobuz/MBTDvoxQFIEGF/f0CXOxM+zEN+r+Dk43DD9kFOA3BbhBuAzC8gxw7EBex7Gdg+P+Gk43dC5sLYOoBxo5/GfwsOCUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/flightDetail/landImg.png
// module id = 4oUQ
// module chunks = 2